import { regEx } from './'

export default (url) => url.match(regEx.urlPath)[0]
